package com.macrofocus.common.units

open class PerUnit(name: String, symbol: String, ratio: Double) : Unit(name, symbol, ratio) {
    companion object Factory {
        val pu = PerUnit("Per-unit", "pu", 1.0)
    }
}

val Number.pu: Quantity<PerUnit> get() = Quantity(this.toDouble(), PerUnit.pu)

